exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-organisms-mobile-MobileEditorPreview-___MobileEditorPreview__previewDisplay___3TIKN {\n  height: 156px;\n  width: 208px;\n  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05);\n}\n\n.src-pc-components-organisms-mobile-MobileEditorPreview-___MobileEditorPreview__transformView___C-uwe {\n  height: 900px;\n  width: 1200px;\n  -webkit-transform: scale(0.17333, 0.17333);\n          transform: scale(0.17333, 0.17333);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n", ""]);

// exports
exports.locals = {
	"previewDisplay": "src-pc-components-organisms-mobile-MobileEditorPreview-___MobileEditorPreview__previewDisplay___3TIKN",
	"transformView": "src-pc-components-organisms-mobile-MobileEditorPreview-___MobileEditorPreview__transformView___C-uwe"
};